import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const AppHeaderWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 0;
`;
